import { render, staticRenderFns } from "./notifyDialog.vue?vue&type=template&id=566a9634&scoped=true&"
import script from "./notifyDialog.vue?vue&type=script&lang=js&"
export * from "./notifyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a9634",
  null
  
)

export default component.exports